import { useEffect, useState } from 'react'
import { FALLBACK_PORTFOLIO } from '@/data/portfolio'
import { api } from '@/lib/api'
import type { PortfolioDTO, PortfolioItem } from '@/types/portfolio'

/**
 * 세 곳(Hero 로고 띠·About KPI·포트폴리오 카드)이 같은 목록을 쓰니 요청 하나를 공유해요.
 * 실패하면 폴백 스냅샷을 돌려줘요 — 목록을 못 받아왔다고 화면이 비면 안 돼요(추적·접수 카운터와 같은 원칙).
 */
let pending: Promise<PortfolioItem[]> | null = null

const loadPortfolio = (): Promise<PortfolioItem[]> => {
  pending ??= api
    .get<PortfolioDTO>('/portfolio')
    .then((dto) => dto.items)
    .catch(() => FALLBACK_PORTFOLIO)
  return pending
}

/**
 * DB 의 포트폴리오 목록. 받아오기 전에는 **빈 목록**이에요.
 *
 * 폴백 스냅샷을 첫 렌더에 쓰지 않는 건 `hidden`(어드민에서 지우지 않고 내린 항목) 때문이에요 —
 * 폴백은 빌드 시점 스냅샷이라 무엇이 내려갔는지 모르고, 그걸 먼저 그리면 내린 항목이 매 로드마다
 * 잠깐 노출돼 '숨김' 이 성립하지 않아요. 대신 첫 페인트 동안 로고 띠·카드·개수가 비어 있어요.
 */
export function usePortfolio(): PortfolioItem[] {
  const [items, setItems] = useState<PortfolioItem[]>([])

  useEffect(() => {
    let alive = true
    loadPortfolio().then((next) => {
      if (alive) setItems(next)
    })
    return () => {
      alive = false
    }
  }, [])

  return items
}
